import { render } from "./RoomGuardianGhostModal.vue?vue&type=template&id=3f87cc30&scoped=true"
import script from "./RoomGuardianGhostModal.vue?vue&type=script&lang=js"
export * from "./RoomGuardianGhostModal.vue?vue&type=script&lang=js"

import "./RoomGuardianGhostModal.vue?vue&type=style&index=0&id=3f87cc30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f87cc30"]])

export default __exports__